import React, { Component, Fragment } from 'react';
import Modal from 'react-bootstrap/Modal';
import { BallBeat } from '../../Loader/loader';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import './saved.scss';

class AddPodModal extends Component {
    state = {
        name: '',
        imageUrl: '/images/sample.svg',
        imageName: '',
        image: 'https://elite-product-images.s3.ap-south-1.amazonaws.com/articles_default_1.png',
        code: '',
        chars_left: 75,
        maxChar: 75,
        isLoading: false,
        update: false
    }

    componentDidMount = () => {
        if (this.props.edit && this.props.items !== null) {
            const { items } = this.props
            items !== undefined && this.setState({
                name: items?.title,
                imageUrl: items?.image,
                image: items?.image,
                id: items?._id,
                chars_left: this.state.maxChar - items.title.length
            })
        }
        else {
            this.setState({
                imageUrl: 'https://elite-product-images.s3.ap-south-1.amazonaws.com/articles_default_1.png',
            })

        }
    }
    changeName = (val) => {
        const charCount = val.length;
        const maxChar = this.state.maxChar;
        const charLength = maxChar - charCount;
        this.setState({
            name: val,
            nameError: '',
            chars_left: charLength
        })
    }
    changeImage = (e) => {
        if (e.target.files[0].size > 2097152) {
            this.setState({
                successMsg: true,
                successMessageText: "The file size cannot exceed 2MB",
            });
        } else {
            const file = this.refs.uploadImg.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState({
                    imageUrl: reader.result,
                });
            };
            if (file) {
                reader.readAsDataURL(file);
                this.setState({
                    imageUrl: reader.result,
                    imageName: file.name,
                    image: file,
                    imageError: "",
                    update: true
                });
            } else {
                this.setState({
                    imageUrl: "",
                    imageName: "",
                    update: false
                });
            }
        }
    };

    savePod = async () => {
        if (this.state.name === "") {
            this.setState({
                nameError: "Please enter Skill pod name",
            });
        } else if (this.state.image === '') {
            this.setState({
                imageError: 'Pleser upload image for pod'
            })
        }
        else {
            let obj = {
                title: this.state.name,
                image: this.state.image,
            }
            this.setState({
                isLoading: true
            })
            await this.props.clearErrors();
            await this.props.savedPod(obj);
            if (window.location.pathname === '/feeds' || window.location.pathname === '/my-content' || this.props.active === 'likes' || window.location.pathname === '/learn/skill-explorer' || window.location.pathname.includes('learn/skill')) {
                let obj = {
                    pod_id: this.props.podDetails?._id,
                    type: this.props.rtype,
                    _id: this.props.rId
                }
                await this.props.addResourceToPod(obj);
                await this.props.resetModal();
                await this.props.handleModal();
                // if (this.props.status === 200) {
                // this.props.getSaved(this.props.rId);
                // }
            }
            else {
                let obj = {
                    pod_id: this.props.podDetails?._id,
                    type: this.props.rtype,
                    _id: this.props.rId
                }
                // await this.props.addResourceToPod(obj);
                await this.props.resetModal();
                this.props.history.push({
                    pathname: `saved/skill-pod`,
                    state: {
                        details: { ...this.props.podDetails, shared: false },
                    }
                });

            }
            this.setState({
                name: '',
                image: '',
                imageName: '',
                imageUrl: '/images/empty-image.svg',
                isLoading: false,
            })
        }
    }
    updatePod = async () => {
        if (this.state.name === '') {
            this.setState({
                nameError: 'Please enter unit name'
            })
        }
        else if (this.state.image === '') {
            this.setState({
                imageError: 'Pleser upload image'
            })
        }
        else {

            var obj = {
                title: this.state.name,
                _id: this.state.id,
                image: this.state.image,
                imageUrl: this.state.imageUrl
            }
            this.setState({
                isLoading: true
            })
            await this.props.clearErrors();
            await this.props.updatePod(obj);
            this.setState({
                isAddTopic: false,
                name: '',
                image: '',
                imageName: '',
                imageUrl: '/images/empty-image.svg',
                isLoading: false,
                update: false
            })
        }
    }
    handleModal = async () => {
        this.props.handleModal();
        this.setState({
            name: '',
            image: '',
            nameError: '',
            imageError: '',
            maxChar: 75,
            chars_left: 75,
            isLoading: false
        })
    }
    render() {
        const { edit, t, theme } = this.props
        return (
            <Fragment>
                <Modal.Body style={{ padding: '22px 37px 22px 37px', }}>
                    <h1 className='text-center'>{edit ? t('Edit Skill Pod', { ns: 'saved' }) : t('Add Skill Pod', { ns: 'saved' })} </h1>

                    <div className="sticky-close" onClick={this.props.handleModal} style={{ top: 15 }}>
                        <img src="/images/close.svg" width='15px' alt='' /></div>
                    <div>
                        <label>{t('Skill Pod Name', { ns: 'saved' })}*
                            <aside className='float-right'>{this.state.chars_left}</aside>
                        </label>
                        <input className='form-control mt-2' placeholder='Add skill pod name here' value={this.state.name} maxLength={this.state.maxChar} onChange={(e) => this.changeName(e.target.value)} />
                    </div>
                    <small style={{ color: 'red' }}>{this.state.nameError}</small>

                    <div className='mt-4'>
                        <label>{t('Skill Pod Image', { ns: 'saved' })}*</label>
                        {
                            this.state.image ?
                                <div className='upload-box'>
                                    <img src={this.state.imageUrl} alt='' width='100%' height={215} className='wid' />
                                    <div className='upload-symbol'>
                                        <div className='upload-circle' style={{ backgroundColor: theme?.bgColor }}>
                                            <img src='/images/upload-white.svg' alt='' />
                                            <input type='file' ref="uploadImg" className='file-upload'
                                                name="selectedFile" accept="image/png, image/jpeg,.pdf,.doc" onChange={this.changeImage} />
                                        </div>
                                    </div>
                                </div> :
                                <div className='upload-box'>
                                    <input type='file' ref="uploadImg" className='file-upload'
                                        name="selectedFile" accept="image/png, image/jpeg,.pdf,.doc" onChange={this.changeImage} />
                                    <div className='d-flex align-items-center'>
                                        <img src='/images/upload1.svg' alt='' /> &nbsp;{t('Upload Image')}
                                    </div>
                                </div>
                        }
                    </div>
                    <small style={{ color: 'red' }}>{this.state.imageError}</small>
                    <div className='save-btn '>
                        {
                            edit ?
                                <button style={{ backgroundColor: theme?.bgColor }} className='position-relative' onClick={this.updatePod} >
                                    {this.state.isLoading ? <div className='ballbeat'><BallBeat color="#fff" /></div> : t('save')}</button>
                                :
                                <button style={{ backgroundColor: theme?.bgColor }} className='position-relative' onClick={this.savePod}>
                                    {this.state.isLoading ? <div className='ballbeat'><BallBeat color="#fff" /></div> : t('save')}</button>
                        }&nbsp;&nbsp;
                        <button onClick={this.handleModal}>{t('cancel')}</button>
                    </div>
                </Modal.Body>
            </Fragment >
        )
    }
}


export default withTranslation(['common', 'saved'])(withRouter(AddPodModal))